import React from 'react';

const WaterIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} viewBox="0 0 64 64" fill="none">
    <ellipse cx="32" cy="44" rx="16" ry="12" fill="#b3e5fc" />
    <path
      d="M32 8C32 8 16 32 16 44C16 54 48 54 48 44C48 32 32 8 32 8Z"
      fill="#4fc3f7"
      stroke="#0288d1"
      strokeWidth="2"
    />
    <ellipse cx="32" cy="44" rx="10" ry="6" fill="#e1f5fe" opacity="0.7" />
  </svg>
);

export default WaterIcon;
